import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly _spinnerStatus$ = new BehaviorSubject<boolean>(false);

  readonly spinnerStatus$ = this._spinnerStatus$.asObservable();

  constructor() {}

  public show(): void {
    this._spinnerStatus$.next(true);
  }

  public hide(): void {
    this._spinnerStatus$.next(false);
  }

  public status(): boolean {
    return this._spinnerStatus$.getValue();
  }

  public showAndHideAfter(milisecs: number): void {
    this.show();
    setTimeout(() => this.hide(), milisecs);
  }
}
